import React, { Component } from "react"
import { MeetingSummaryTable } from "./MeetingSummaryTable"
import { FamilyDebts } from "./FamilyDebts"
import { FamilyDebtsStatus } from "./FamilyDebtsStatus" 
import { FamilyLegal } from "./FamilyLegal" 
import { FamilyIncome } from "./FamilyIncome" 
import { FamilyExpenses } from "./FamilyExpenses" 
import { FamilyBalance } from "./FamilyBalance" 
import { FamilyProductsServices } from "./FamilyProductsServices" 
import { FamilySavings } from "./FamilySavings" 
import { FamilyContact } from "./FamilyContact"
import { FamilyHousing } from "./FamilyHousing"
// import { FamilyGeneral } from "./FamilyGeneral"
import { FamilyMortgage } from "./FamilyMortgage"
import { FamilyRights } from "./FamilyRights"
import { FamilyRightsQ } from "./FamilyRightsQ"
import { FamilyWP4 } from './FamilyWP4'
import { FamilyProgramQ } from "./FamilyProgramQ"
//import { FamilyProgramQfinal } from "./FamilyProgramQfinal"
import { FamilyProgramQend } from "./FamilyProgramQend"
import { FamilyParent } from "../FamilyParent/FamilyParent"
import { FamilyKids } from './FamilyKids'
import { FamilySnapshot } from './FamilySnapshot'
import { RightsInfo } from './RightsInfo'
import { FamilyImprove } from './FamilyImprove'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
//import WorkPlan from "./WorkPlan"
//import { FamilyLogTable } from "./FamilyLogTable"
import { NeedSolutionsTable } from "./NeedSolutionsTable"
import { saveSubAcf2DB } from '../Tree/Utils'
import { GetFamiliesEP, /*, DevBuild */ } from '../../variables/Config' 
import { HostUrl } from '../../variables/DigmaDef'

import YSpinner from  '../../elements/Spinner/Spinner'

export const familyNames = (family_name, female_name, male_name) => {
    
    return <h5 className="family-name-style">
              <span className="fname-label">משפחת:&nbsp;</span>
              <span className="fname-name">{family_name}</span>
              <span className="fname-female">&nbsp;{female_name}</span>
              <span className="fname-male">
                  &nbsp;{female_name.length && male_name.length ? "ו" : ""}{male_name}</span>
        </h5>
}

const compare_dates = (cdate, n) => {
    let today = new Date()
    let cd = cdate.split('/')
    let pdate = new Date(cd[2]+'-'+cd[1]+'-'+cd[0])
    let oneday = 24*3600*1000 // in millisec
    let diff = Math.round((today.getTime() - pdate.getTime()) / oneday)
    // console.log('compare_dates = ' + cd[2]+'-'+cd[1]+'-'+cd[0] )
    return diff > n // true if more than n
}
const emptyObj = (obj) => {
    if (obj === undefined || (Object.entries(obj).length === 0 && obj.constructor === Object)) 
        return true
   // look in each field 
    for(var prop in obj) {
        if (obj[prop] !== "")
           return false
    }
    return true
}
// missing first snapshot
const missingSnapShot = (program_info, all) => {
    let after90days = compare_dates(program_info['program_date'], 90) // after 90 days in program
    let result = ""
    if (program_info['program_status'] === 'בתכנית' && after90days){
        if (program_info['program_end_data1_date'] === '')
            result += 'משפחה >> מידע כללי >> שלב קליטת נתונים לא מוגדר. '
        if (all.snapshots === undefined || all.snapshots.length < 1)
            result += 'חסרה תמונת מצב התחלה'
    }
    return result

}
const missingData = (program_info, all) => {
    // family in program & > 90 days && missing data
    // else return null
    ////console.log('missingData program_info', program_info)
    let after90days = compare_dates(program_info['program_date'], 90) // after 90 days in program
    let result = ""
    if (program_info['program_status'] === 'בתכנית' && after90days){
        if (emptyObj(all['family_housing']))
            result += ' דיור'
        if (emptyObj(all['family_legal']))
            result += ' משפטי'
        if (emptyObj(all['debts_status']))
            result += ' מצב חובות'
        if (emptyObj(all['family_savings']))
            result += ' חסכון'
        if (all['family_income'] === undefined || all['family_income'].length < 2 )
            result += ' הכנסות'
        if (all['family_expenses'] === undefined || all['family_expenses'].length < 2 )
            result += ' הוצאות'
        if (all['family_kids'] === undefined || all['family_kids'].length !== parseInt(program_info['kids_number']) )
            result += ' ילדים'
    }
    return result
}
export default class ProgramTabs extends Component {
    constructor(props){
        super(props)
        this._isMounted = false;
        this.state = {
            //cptId : this.props.cptId, // 6296, // get from props
            isLoading: true, // LOAD vs. UPDATE
            isUpdating: false,
            restError:"",
            cpt: {} //terms: [], // ,            familylog_array: []
        }
        // this.inUpdate = this.inUpdate.bind(this)
        //this.onSaveSubTable = this.onSaveSubTable.bind(this)
        //this.parentqReport = this.parentqReport.bind(this)
        //this.update_sstable = this.update_sstable.bind(this)
    }
    inUpdate = onOff => {
        //console.log("inUpdate =", onOff)
        if (this._isMounted)
            this.setState({isUpdating:onOff})
    }
    update_sstable= (snap_result) => {
        let newcpt = Object.assign(this.state.cpt)
        newcpt['snapshots'] = Object.assign(snap_result)
        this.setState({cpt: newcpt, snapshot: snap_result})
    }

    fetchTerm(url) {
        fetch(url ,{headers: {'Accept-Encoding' : 'gzip'}})
        .then(response => {
            if (!this._isMounted) return null
            if (response.ok)
                return response.json()
            throw new Error('fetchTerm: Something went wrong ...')
        })
        .then(cpt => {             
            if (!this._isMounted) 
                return null
            
            this.setState({cpt, isLoading: false}) 
            return (cpt['acf']) // can be void - no one is looking...
        }).then( () => {
            //console.log("title",this.state.cpt['title'])
            //console.log("FAMILYLOG",this.state.cpt['acf']['familylog_array'])
            //console.log("family_basic",this.state.cpt['acf']['family_basic'])
        })
        .catch(restError => {
            if (!this._isMounted) return null
            if (restError.name === 'AbortError') return; 
            this.setState({ restError: restError, isLoading: false })
        })
        return null
    }
    componentDidMount(){ // add constructor..
        this._isMounted = true
        //this.setState({isLoading: true  })     // modalRoot: document.getElementById('modal-root'),
        //var uri = "http://yahav/wp-json/wp/v2/digma_families/"+ this.state.cptId +"?fields=id,title,acf" 
        //const fields = "per_page=100&fields=id,title,acf";
        const uri = GetFamiliesEP() + "/" + this.props.cptId +"?fields=id,title,acf" 

        this.fetchTerm(uri)

        //// TODOOO get async. combo!!
        // get from props family CPT ID

        // get from DB all family combo staff

        // get from DB family data & propagate as props to tabls...
    }

    componentWillUnmount(){ 
        this._isMounted = false
    }
    // need id, table id & data
    // modify DB and parent state

    onSaveSubTable = (cptId, data, dataId, dataType, inUpdate) => {
        // console.log("onSaveSubTable: dataId = ", dataId)
        const {cpt} = this.state
        //if (JSON.stringify(cpt['acf'][dataId]) === JSON.stringify(data) )
        //    return console.log("No change in "+dataId +"  ", data)
        saveSubAcf2DB(cptId, data, dataId, dataType, inUpdate, this.props.mbouser)
        let newCpt = Object.assign(cpt)
        newCpt['acf'][dataId] = Object.assign(data)
        this.setState({cpt:newCpt})
        return null
    }

    getAmadotShortcodeLink(cptId, family_members){
        let fmembers = family_members[0]['family_member_cptid'];
        if (family_members.length > 1)
            fmembers += ","+family_members[1]['family_member_cptid']
        return (HostUrl+"/parentqcs?family="+cptId+"&parent="+fmembers)
    }
    parentqReport = (cptId, family_members) => {
    /*        let fmembers = family_members[0]['family_member_cptid'];
            if (family_members.length > 1)
                fmembers += ","+family_members[1]['family_member_cptid']
            let sclink = HostUrl+"/parentqcs?family="+cptId+"&parent="+fmembers*/
            return (
                <a href={this.getAmadotShortcodeLink(cptId, family_members)} target="_blank" rel="noopener noreferrer" >השוואת שאלוני עמדות</a>
            )
    }
    render(){
        if (this.state.isLoading)
            return <YSpinner />
        if (this.state.restError !== "")
            return <h2>תקלה חולפת: {this.state.restError}</h2>    
        const {mbouser, cptId} = this.props
        const a = this.state.cpt['acf']
        const familyPostId = cptId // get as input from list
        const family_meeting_summary = a['family_meeting_summary']
        const program_info = a['program_info']
        const family_housing = a['family_housing']
        const family_legal = a['family_legal']
        const family_income = a['family_income'] 
        const family_debts = a['family_debts'] 
        const family_savings = a['family_savings'] 
        const family_expenses = a['family_expenses']
        const debts_status = a['debts_status']
        const family_balance = a['family_balance']
        const family_products_services = a['family_products_services']
        const family_products_services_end = a['family_products_services_end']
        const family_mortgage = a['family_mortgage']
        const family_rights = a['family_rights'] 
        const rights_q = a['rights_q'] 
        const family_members = a['family_members'] 
        const family_kids = a['family_kids'] 
        //const familywp_finance = a['familywp_finance'] // familywp_finance_2
        const familywp_finance_2 = a['familywp_finance_2'] // familywp_finance_2
        //const familywp_employ = a['familywp_employ'] 
        const familywp_employ_2 = a['familywp_employ_2'] 
        //const familywp_family = a['familywp_family'] 
        const familywp_family_2 = a['familywp_family_2'] 
        const questionnaire_1year = a['questionnaire_1year'] 
        const questionnaire_2year = a['questionnaire_2year'] 
        //const familylog_array = a['familylog_array']
        const needsolution_array = a['needsolution_array']
        const snapshots = a['snapshots'] === undefined ? null : a['snapshots']
        const snapshotsExists = a['snapshots'] !== undefined && a['snapshots'].length > 0 

        const manExists = program_info['intake_family_man_name'].length
        const womanExists = program_info['intake_family_woman_name'].length
        // console.log("manExists ="+manExists+"<< womanExists="+womanExists+"<<")
        // console.log("Program Tabs cpt[acf]=", a)
        var missingTabData = missingData(program_info, a)
        missingTabData = missingTabData === "" ? "" : <span className='missing-tabs-list'>[חסר מידע בלשוניות: {missingTabData}]</span>
        var missingFirstSnapshot = missingSnapShot(program_info, a)
        missingFirstSnapshot = missingFirstSnapshot === "" ? "" : <span className='missing-tabs-list'>[{missingFirstSnapshot}]</span>

        return(    
            <Tabs>
                {this.state.isUpdating ? <YSpinner message={"מעדכן..."} /> : null }
                {/*this.familyNames(program_info)*/}
                {familyNames(program_info['intake_family_name'], 
                                program_info['intake_family_woman_name'], 
                                program_info['intake_family_man_name'])}
                {missingTabData}
                {missingFirstSnapshot}
                <TabList>
                    <Tab>סיכומי מפגש</Tab>
                    <Tab>נתוני המשפחה</Tab>
                    {!womanExists? "" : <Tab><span className="fname-female">נתוני {a['program_info']['intake_family_woman_name']}</span></Tab>}
                    {!manExists  ? "" : <Tab><span className="fname-male">נתוני {a['program_info']['intake_family_man_name']}</span></Tab>}
                    <Tab>ילדים</Tab>
                    <Tab>תכנית עבודה</Tab>
                    {mbouser.user_role[0] === "administrator" ? <Tab>צרכים ומענים++</Tab> : <Tab>צרכים ומענים</Tab> }
                    <Tab>חוות דעת</Tab>
                    { /*DevBuild &&*/ snapshotsExists && <Tab>מדדי שיפור</Tab>}
                    <Tab>תמונת מצב</Tab>
                    <Tab>כלים</Tab>
                </TabList>
                <br /><br />
                <TabPanel>               
                    <MeetingSummaryTable tableTitle={"סיכומי מפגשים"} 
                            familyPostId={familyPostId} 
                            data={family_meeting_summary /*this.state.family_meeting_summary*/}
                            subTableId = {"family_meeting_summary"}
                            inUpdate = {this.inUpdate}
                            mbouser = { mbouser }
                            save2DB = {this.onSaveSubTable} />
                </TabPanel>
               
                <TabPanel>
                    <Tabs className="float-right" >
                        <TabList>
                            <Tab>מידע כללי</Tab>
                            <Tab>דיור</Tab>
                            <Tab>משפטי</Tab>
                            <Tab>הכנסות</Tab>
                            <Tab>הוצאות</Tab>
                            <Tab>התחייבויות</Tab>
                            <Tab>חסכון</Tab>
                            <Tab>מאזן</Tab>
                            <Tab>מוצרים ושירותים</Tab>
                            <Tab>מיצוי זכויות</Tab>
                        </TabList>
                        <TabPanel>
                            <FamilyContact tableTitle={"פרטים כלליים"} 
                                familyPostId={familyPostId} 
                                data={program_info}
                                subTableId = {"program_info"}
                                inUpdate = {this.inUpdate}
                                mbouser = { mbouser }
                                mteamMember = {this.props.mteamMember}
                                save2DB = {this.onSaveSubTable} />
                        </TabPanel>
                        <TabPanel>
                            <FamilyHousing tableTitle={"מצב דיור"} 
                                familyPostId={familyPostId} 
                                data={family_housing}
                                subTableId = {"family_housing"}
                                inUpdate = {this.inUpdate}
                                mbouser = { mbouser }
                                save2DB = {this.onSaveSubTable} />
                        </TabPanel>
                        <TabPanel>
                            <FamilyLegal tableTitle={"מצב משפטי"} 
                                familyPostId={familyPostId} 
                                data={family_legal}
                                subTableId = {"family_legal"}
                                inUpdate = {this.inUpdate}
                                mbouser = { mbouser }
                                save2DB = {this.onSaveSubTable} />
                        </TabPanel>
                        <TabPanel>
                            <FamilyIncome tableTitle={"הכנסות"} 
                                familyPostId={familyPostId} 
                                data={family_income}
                                subTableId = {"family_income"}
                                inUpdate = {this.inUpdate}
                                mbouser = { mbouser }
                                save2DB = {this.onSaveSubTable} />
                            <br />
                            <FamilyRights tableTitle={"מיצוי זכויות"} 
                                familyPostId={familyPostId} 
                                data={family_rights}
                                subTableId = {"family_rights"}
                                inUpdate = {this.inUpdate}
                                mbouser = { mbouser }
                                save2DB = {this.onSaveSubTable} />
                        </TabPanel>
                        <TabPanel>
                            <FamilyExpenses tableTitle={"הוצאות"} 
                                familyPostId={familyPostId} 
                                data={family_expenses}
                                subTableId = {"family_expenses"}
                                inUpdate = {this.inUpdate}
                                mbouser = { mbouser }
                                save2DB = {this.onSaveSubTable} />
                        </TabPanel>
                        <TabPanel>
                            <FamilyDebtsStatus tableTitle={"מצב חובות"} 
                                familyPostId={familyPostId} 
                                data={debts_status}
                                subTableId = {"debts_status"}
                                inUpdate = {this.inUpdate}
                                mbouser = { mbouser }
                                save2DB = {this.onSaveSubTable} />
                            <br />
                            <FamilyDebts tableTitle={"חובות והלוואות"} 
                                familyPostId={familyPostId} 
                                data={family_debts}
                                subTableId = {"family_debts"}
                                inUpdate = {this.inUpdate}
                                mbouser = { mbouser }
                                save2DB = {this.onSaveSubTable} />
                            <br />
                            <FamilyMortgage tableTitle={"משכנתאות"} 
                                familyPostId={familyPostId} 
                                data={family_mortgage}
                                subTableId = {"family_mortgage"}
                                inUpdate = {this.inUpdate}
                                mbouser = { mbouser }
                                save2DB = {this.onSaveSubTable} />
                        </TabPanel>
                        <TabPanel>
                            <FamilySavings tableTitle={"חסכון"} 
                                familyPostId={familyPostId} 
                                data={family_savings}
                                subTableId = {"family_savings"}
                                inUpdate = {this.inUpdate}
                                mbouser = { mbouser }
                                save2DB = {this.onSaveSubTable} />
                        </TabPanel>
                        <TabPanel>
                            <FamilyBalance tableTitle={"מאזן חודשי הוצאות מול הכנסות"} 
                                familyPostId={familyPostId} 
                                data={family_balance}
                                subTableId = {"family_balance"}
                                cpt = { a }
                                inUpdate = {this.inUpdate}
                                mbouser = { mbouser }
                                save2DB = {this.onSaveSubTable} />
                            <br />
                        </TabPanel>
                        <TabPanel>
                            <Tabs>
                                <TabList>
                                    <Tab>בתחילת תוכנית</Tab>
                                    <Tab>בסיום תוכנית</Tab>
                                </TabList>
                                <TabPanel>
                                    <FamilyProductsServices tableTitle={"מוצרים ושירותים - בתחילת התוכנית"} 
                                        familyPostId={familyPostId} 
                                        data={family_products_services}
                                        subTableId = {"family_products_services"}
                                        inUpdate = {this.inUpdate}
                                        mbouser = { mbouser }
                                        save2DB = {this.onSaveSubTable} />
                                    </TabPanel>
                                <TabPanel>
                                    <FamilyProductsServices tableTitle={"מוצרים ושירותים- בסיום התוכנית"} 
                                        familyPostId={familyPostId} 
                                        data={family_products_services_end}
                                        subTableId = {"family_products_services_end"}
                                        inUpdate = {this.inUpdate}
                                        mbouser = { mbouser }
                                        save2DB = {this.onSaveSubTable} />
                                </TabPanel>
                            </Tabs>
                        </TabPanel>
                        <TabPanel>
                            <FamilyRightsQ tableTitle={"מצב מיצוי הזכויות"} 
                                familyPostId={familyPostId} 
                                data={rights_q}
                                subTableId = {"rights_q"}
                                inUpdate = {this.inUpdate}
                                mbouser = { mbouser }
                                save2DB = {this.onSaveSubTable} />
                        </TabPanel>
                    </Tabs>
                </TabPanel>
 
                {!womanExists ? "" : <TabPanel>
                    {family_members.map ( x => {
                        if (x['family_member_role'] === "mother" && x['family_member_cptid'])
                            return (
                                <FamilyParent key={x['family_member_cptid']} tableTitle={"נתוני האשה"}
                                    data = {family_members}
                                    memberPostId= {x['family_member_cptid']} // {familyPostId}     // should I send it? or just the parents Id table
                                    // subTableId = {"family_members"} // REDUNDANT its in parent post type
                                    inUpdate = {this.inUpdate}
                                    mbouser = { mbouser }
                                    save2DB = {this.onSaveSubTable}  // REDUNDANT save is done at sub component level
                                />
                            )
                        return null                        
                    })}
                </TabPanel>
                }
                {!manExists ? "" : <TabPanel>
                    {family_members.map ( x => {
                        if (x['family_member_role'] === "father" && x['family_member_cptid'])
                            return (
                                <FamilyParent key={x['family_member_cptid']} tableTitle={"נתוני הגבר"}
                                    data = {family_members}
                                    memberPostId= {x['family_member_cptid']} // {familyPostId}     // should I send it? or just the parents Id table
                                    // subTableId = {"family_members"} // REDUNDANT its in parent post type
                                    inUpdate = {this.inUpdate}
                                    mbouser = { mbouser }
                                    save2DB = {this.onSaveSubTable}  // REDUNDANT save is done at sub component level
                                />
                            )
                        return null
                        
                    })}
                </TabPanel>
                }
                <TabPanel>               
                    <FamilyKids tableTitle={"ילדים"} 
                            familyPostId={familyPostId} 
                            data={family_kids}
                            subTableId = {"family_kids"}
                            inUpdate = {this.inUpdate}
                            mbouser = { mbouser }
                            save2DB = {this.onSaveSubTable} />
                </TabPanel>
                <TabPanel>
                    <Tabs>
                        <TabList>
                                <Tab>כלכלה</Tab>
                                <Tab>תעסוקה</Tab>
                                <Tab>משפחה</Tab>
                        </TabList>
                        <TabPanel>
                            <FamilyWP4 tableTitle={"תכנית עבודה כלכלה"} 
                                familyPostId={familyPostId} 
                                data={familywp_finance_2}
                                subTableId = {"familywp_finance_2"}
                                inUpdate = {this.inUpdate}
                                mbouser = { mbouser }
                                save2DB = {this.onSaveSubTable} />
                        </TabPanel>
                        <TabPanel>
                            <FamilyWP4 tableTitle={"תכנית עבודה לתעסוקה"} 
                                familyPostId={familyPostId} 
                                data={familywp_employ_2}
                                subTableId = {"familywp_employ_2"}
                                inUpdate = {this.inUpdate}
                                mbouser = { mbouser }
                                save2DB = {this.onSaveSubTable} />
                        </TabPanel>
                        <TabPanel>
                        <FamilyWP4 tableTitle={"תכנית עבודה למשפחה"} 
                            familyPostId={familyPostId} 
                            data={familywp_family_2}
                            subTableId = {"familywp_family_2"}
                            inUpdate = {this.inUpdate}
                            mbouser = { mbouser }
                            save2DB = {this.onSaveSubTable} />
                    </TabPanel>
                    </Tabs>
                </TabPanel>

                    
            { mbouser.user_role[0] !== "administrator" 
                ? 
                    <TabPanel>               
                        <NeedSolutionsTable tableTitle={"צרכים ומענים"} 
                        // TODO ADD & Replace with data = {this.state.needsolutionarray}
                                familyPostId={familyPostId}
                                subTableId = {"needsolution_array"} 
                                data = {needsolution_array}
                                fullTable={false}
                                inUpdate = {this.inUpdate}
                                mbouser = { mbouser }
                                save2DB = {this.onSaveSubTable} />
                    </TabPanel>
                :
                    <TabPanel>               
                        <NeedSolutionsTable tableTitle={"צרכים ומענים - מנהלת"} 
                        // TODO ADD & Replace with data = {this.state.needsolutionarray}
                                familyPostId={familyPostId}
                                subTableId = {"needsolution_array"} 
                                data = {needsolution_array}
                                fullTable={true}
                                inUpdate = {this.inUpdate}
                                mbouser = { mbouser }
                                save2DB = {this.onSaveSubTable} />
                    </TabPanel>  
            }
            <TabPanel>
                    <Tabs>
                                <TabList>
                                    <Tab>אחרי שנה</Tab>
                                    <Tab>בסיום התוכנית</Tab>
                                </TabList>
                                <TabPanel>
                                    <FamilyProgramQ tableTitle={"חוות דעת ושביעות רצון אחרי שנה"} 
                                        familyPostId={familyPostId} 
                                        data={questionnaire_1year}
                                        subTableId = {"questionnaire_1year"}
                                        inUpdate = {this.inUpdate}
                                        mbouser = { mbouser }
                                        save2DB = {this.onSaveSubTable} />
                                </TabPanel>
                                <TabPanel>

                                <FamilyProgramQend tableTitle={"חוות דעת ושביעות רצון אחרי שנתיים"} 
                                    familyPostId={familyPostId} 
                                    data={questionnaire_2year}
                                    subTableId = {"questionnaire_2year"}
                                    inUpdate = {this.inUpdate}
                                    mbouser = { mbouser }
                                    save2DB = {this.onSaveSubTable} />
                                </TabPanel>                                
                    </Tabs>
                    </TabPanel>
                    { /*DevBuild &&*/ snapshotsExists && 
                        <TabPanel>
                        <FamilyImprove tableTitle={"מדדי שיפור"}
                            data = {snapshots}
                            acf = {a}
                            cpt = {this.state.cpt}
                            userrole = {mbouser.userrole}
                            familyPostId={familyPostId}
                            subTableId = {"snapshots"} 
                            inUpdate = {this.inUpdate}
                            update_sstable = {this.update_sstable}
                            mbouser = { mbouser }
                            save2DB = {this.onSaveSubTable} />
                    </TabPanel> }
                    <TabPanel>
                        <FamilySnapshot tableTitle={"תמונת מצב"}
                            data = {snapshots}
                            acf = {a}
                            cpt = {this.state.cpt}
                            userrole = {mbouser.userrole}
                            familyPostId={familyPostId}
                            subTableId = {"snapshots"} 
                            inUpdate = {this.inUpdate}
                            update_sstable = {this.update_sstable}
                            mbouser = { mbouser }
                            save2DB = {this.onSaveSubTable} />
                    </TabPanel>
                    <TabPanel>
                        <RightsInfo cptId={cptId} getAmadotShortcodeLink={this.getAmadotShortcodeLink} {...this.state.cpt['acf']} />
                    </TabPanel>
            </Tabs>         
        )
    }
}
